var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.computedTabType
    ? _c(
        "div",
        {
          ref: "tabsContainer",
          staticClass: "casino-tabs-container",
          class: [_vm.section]
        },
        [
          _c(
            "v-tabs",
            {
              ref: "vTabs",
              on: { change: _vm.onTabChange },
              model: {
                value: _vm.selectedTab,
                callback: function($$v) {
                  _vm.selectedTab = $$v
                },
                expression: "selectedTab"
              }
            },
            [
              _c(
                "div",
                { staticClass: "tabs-wrapper" },
                [
                  ["filterAndSort"].includes(_vm.section)
                    ? _c("v-tab", { staticClass: "dummy-tab" })
                    : _vm._e(),
                  _vm._v(" "),
                  !["filterAndSort"].includes(_vm.section)
                    ? _vm._l(_vm.computedTabType, function(n, index) {
                        return _c(
                          "v-tab",
                          {
                            key: n,
                            ref: function(el) {
                              return (_vm.tabRefs[index] = el)
                            },
                            refInFor: true,
                            staticClass: "tab-item",
                            class: [{ "tab-disabled": _vm.itemCount === 0 }, n],
                            attrs: { ripple: false }
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.$t(_vm.tabsTranslation[n])) +
                                "\n        "
                            )
                          ]
                        )
                      })
                    : [
                        _vm._l(_vm.computedTabType, function(n, index) {
                          return [
                            n === "FilterBy"
                              ? [
                                  _c(
                                    "v-tab",
                                    {
                                      key: n,
                                      ref: function(el) {
                                        return (_vm.tabRefs[index] = el)
                                      },
                                      refInFor: true,
                                      staticClass: "tab-item",
                                      class: [
                                        { "tab-disabled": _vm.itemCount === 0 },
                                        n
                                      ],
                                      attrs: { ripple: false },
                                      on: {
                                        click: function($event) {
                                          return _vm.openDrawer(index, n)
                                        }
                                      }
                                    },
                                    [
                                      _c("span", {
                                        staticClass: "tab-icon",
                                        class: [n]
                                      }),
                                      _vm._v(" "),
                                      !_vm.mobileBigAndBelow
                                        ? _c(
                                            "span",
                                            { staticClass: "tab-text" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(_vm.tabsTranslation[n])
                                                )
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.activeKey === n
                                        ? _c("v-icon", [_vm._v("expand_less")])
                                        : _c("v-icon", [_vm._v("expand_more")])
                                    ],
                                    1
                                  )
                                ]
                              : [
                                  _c(
                                    "v-menu",
                                    {
                                      key: n,
                                      attrs: {
                                        transition: "none",
                                        "close-on-content-click": false,
                                        "offset-overflow": true,
                                        "offset-y": "",
                                        "nudge-bottom": 10,
                                        "nudge-left": _vm.calculateMenuPosition(
                                          index,
                                          n
                                        ),
                                        "max-width":
                                          n === "RemoveAllFavorites"
                                            ? 250
                                            : 200,
                                        disabled: _vm.itemCount === 0,
                                        "content-class": "casino-tab-menu"
                                      },
                                      on: {
                                        input: function($event) {
                                          return _vm.handleMenuToggle(
                                            $event,
                                            index
                                          )
                                        }
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function(ref) {
                                              var on = ref.on
                                              return [
                                                _c(
                                                  "v-tab",
                                                  _vm._g(
                                                    {
                                                      ref: function(el) {
                                                        return (_vm.tabRefs[
                                                          index
                                                        ] = el)
                                                      },
                                                      refInFor: true,
                                                      staticClass: "tab-item",
                                                      class: [
                                                        {
                                                          "tab-disabled":
                                                            _vm.itemCount === 0
                                                        },
                                                        n
                                                      ],
                                                      attrs: { ripple: false },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.onTabClick(
                                                            index,
                                                            n
                                                          )
                                                        }
                                                      }
                                                    },
                                                    on
                                                  ),
                                                  [
                                                    _c("span", {
                                                      staticClass: "tab-icon",
                                                      class: [n]
                                                    }),
                                                    _vm._v(" "),
                                                    !_vm.mobileBigAndBelow
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "tab-text"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  _vm
                                                                    .tabsTranslation[
                                                                    n
                                                                  ]
                                                                )
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    ![
                                                      "RemoveAllFavorites"
                                                    ].includes(n)
                                                      ? _c(
                                                          "span",
                                                          [
                                                            _vm.activeKey === n
                                                              ? _c("v-icon", [
                                                                  _vm._v(
                                                                    "expand_less"
                                                                  )
                                                                ])
                                                              : _c("v-icon", [
                                                                  _vm._v(
                                                                    "expand_more"
                                                                  )
                                                                ])
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e()
                                                  ]
                                                )
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        true
                                      ),
                                      model: {
                                        value: _vm.menuStates[index],
                                        callback: function($$v) {
                                          _vm.$set(_vm.menuStates, index, $$v)
                                        },
                                        expression: "menuStates[index]"
                                      }
                                    },
                                    [
                                      _vm._v(" "),
                                      _c("filter-and-sort-panel", {
                                        attrs: {
                                          activeKey: n,
                                          itemCount: _vm.itemCount,
                                          providers: _vm.providers,
                                          themeList: _vm.themeList,
                                          filteredItems: _vm.filteredItems,
                                          originalPreparedData:
                                            _vm.originalPreparedData,
                                          pageSection: _vm.pageType
                                        },
                                        on: {
                                          close: function($event) {
                                            return _vm.closeMenu(index)
                                          },
                                          sortTypeSelected:
                                            _vm.handleSortTypeSelected,
                                          filterSelected:
                                            _vm.handleFilterSelected
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]
                          ]
                        })
                      ]
                ],
                2
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "v-navigation-drawer",
            {
              staticClass: "filter-drawer",
              attrs: {
                right: true,
                temporary: "",
                fixed: "",
                width: _vm.drawerWidth
              },
              model: {
                value: _vm.filterDrawer,
                callback: function($$v) {
                  _vm.filterDrawer = $$v
                },
                expression: "filterDrawer"
              }
            },
            [
              _c("filter-and-sort-panel", {
                attrs: {
                  activeKey: "FilterBy",
                  itemCount: _vm.itemCount,
                  providers: _vm.providers,
                  themeList: _vm.themeList,
                  filteredItems: _vm.filteredItems,
                  originalPreparedData: _vm.originalPreparedData,
                  selectedFilterNumberDisplay: _vm.selectedFilterNumberDisplay,
                  pageSection: _vm.pageType
                },
                on: {
                  close: function($event) {
                    _vm.filterDrawer = false
                  },
                  sortTypeSelected: _vm.handleSortTypeSelected,
                  filterSelected: _vm.handleFilterSelected
                }
              })
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-89ff21ce", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-89ff21ce","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/igaming/partials/casinoTabs.vue
// module id = null
// module chunks = 